import { render, staticRenderFns } from "./98.vue?vue&type=template&id=0ecb3a2d&scoped=true&"
var script = {}
import style0 from "./98.vue?vue&type=style&index=0&id=0ecb3a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb3a2d",
  null
  
)

export default component.exports